import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-documents" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-documents-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_RemovableItem = _resolveComponent("RemovableItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BorderedIconButton, {
        for: "uploadFiles",
        class: "add-button",
        imgUrl: _ctx.loadIcon,
        title: _ctx.$t('app.ask.estimate.document'),
        onClick: _ctx.triggerSelect
      }, null, 8, ["imgUrl", "title", "onClick"]),
      _createElementVNode("input", {
        class: "invisible-input",
        id: "uploadFiles",
        ref: "uploadFiles",
        accept: ".jpg, .jpeg, .png, .gif, .pdf",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDocument && _ctx.addDocument(...args))),
        value: this.uploadFilesResetValue(),
        type: "file"
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
        return (_openBlock(), _createBlock(_component_RemovableItem, {
          key: document.name,
          title: document.name,
          onRemove: ($event: any) => (_ctx.removeDocument(document))
        }, null, 8, ["title", "onRemove"]))
      }), 128))
    ])
  ]))
}